/**
 * National Heist scene config (from legacy settings.js).
 * Image filenames resolve via stage1Scenes.js → ./img/
 * dial_cords: percentage placements matched to reference screenshots.
 */
const scene = [
  {
    scene: 1,
    round: 1,
    type: "text_optiion",
    scene_image: "scene1.png",
    info: "",
    dial: [
      "Mr. Smith - The Constitution has a tracking device. Let’s track the location and move quickly",
    ],
    dial_cords: ["left: 4%; bottom: 6%; max-width: 46%;"],
    options: ["A) Edakkal Caves", "B) Borra Caves", "C) Tabo Caves"],
    answer_id: 0,
    has_option_image: false,
    count_points: 5,
  },
  {
    scene: 2,
    round: 2,
    type: "next_button",
    scene_image: "scene1.png",
    info: "",
    dial: [
      "Mr. Smith - It seems that the troupe knew of the tracking device and has led us to this location on purpose",
      "Mr. Woddy - Yes, I concur. Let’s scan the environment for prints or clues that can lead us close to them",
    ],
    dial_cords: [
      "left: 2%; top: 3%; max-width: 48%;",
      "left: 2%; top: 22%; max-width: 48%;",
    ],
    options: [],
    has_option_image: false,
    count_points: 5,
  },
  {
    scene: 3,
    round: 3,
    type: "next_button",
    scene_image: "scene2.png",
    info: "",
    dial: [
      "Mr. Smith - Let’s call the HQ and run this identity proof with the research team to discover his history and current location. ",
    ],
    dial_cords: ["left: 2%; top: 3%; max-width: 48%;"],
    options: [],
    has_option_image: false,
    count_points: 0,
  },
  {
    scene: 4,
    round: 3,
    type: "input_box",
    scene_image: "scene3.png",
    info: "You have now arrived at the warehouse where the Leader and his troupe seem to be in hiding. On scanning the space, you find the chart. Decode the digital code that will reveal their plan of action. ",
    dial: [],
    dial_cords: [],
    options: [],
    answer_id: "1947-08-15",
    has_option_image: false,
    count_points: 5,
  },
  {
    scene: 5,
    round: 4,
    type: "text_optiion",
    scene_image: "scene4.png",
    info: "",
    dial: [
      "Mr. Smith -  It means they have discovered the defence codes! Their motive is to launch a missile attack. But where and why?",
      "Mr. Woddy - We must alter the assembly to activate Plan Ultimatum that will change the defence codes immediately.",
    ],
    dial_cords: [
      "left: 2%; top: 3%; max-width: 52%;",
      "left: 2%; bottom: 6%; max-width: 42%;",
    ],
    options: [
      "Restore factory setting",
      "Restore default setting",
      "Restore new settings",
    ],
    answer_id: 1,
    has_option_image: false,
    count_points: 5,
  },
  {
    scene: 6,
    round: 5,
    type: "text_optiion",
    scene_image: "scene5.png",
    info: "Identify the right pattern based on the top view of the signals to trace the Constitution and return it back to its right place! ",
    dial: [
      "Mr. Smith - Now that Plan Ultimatum has been successfully implemented, the troupe will be unable to activate the defence codes. But they still have our Constitution in custody. ",
      "Mr. Woddy - Our satellites are now receiving the live location of the Constitution with the activation of Plan Ultimatum",
    ],
    dial_cords: [
      "right: 1%; bottom: 6%; max-width: 42%;",
      "right: 1%; top: 3%; max-width: 40%;",
    ],
    options: ["1.png", "4.png", "3.png"],
    answer_id: 2,
    has_option_image: true,
    count_points: 5,
  },
];

export default scene;
export { scene };
